import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Footer from './components/common/Footer';
import Route from './routes';
import Header from './components/common/Header';
import { trackPageView } from './utils/tracker';
import AuthContext from './context/AuthContext';
import AssistantLauncher from './components/assistant/AssistantLauncher';
import ConsentGate from './components/consent/ConsentGate';

function App() {
    const location = useLocation();
    const { isAuthenticated, userRole } = useContext(AuthContext);

    // Scroll to top and track page view on route change
    useEffect(() => {
        window.scrollTo(0, 0);
        const userId = null; // anonymous — extend later if auth context available
        trackPageView(userId);
    }, [location.pathname]);

    // AI assistant is for visitors and jobseekers only — hidden on
    // admin/recruiter routes, and for any authenticated non-jobseeker
    // (the JWT stores role as an object {id, name}, older code as a string).
    const roleName = typeof userRole === 'string' ? userRole : userRole?.name;
    const isAssistantRoute =
        !location.pathname.startsWith('/admin') && !location.pathname.startsWith('/recruiter');
    const isAssistantRole = !isAuthenticated || roleName === 'jobseeker';
    const isChatbotEnabled = process.env.REACT_APP_SHOW_CHATBOT !== 'false';

    return (
        <>
            <Route />
            {/*
              * Mounted app-wide rather than per route: the gate has to appear
              * wherever an authenticated member lands after logging in, and it
              * renders nothing at all unless the server says consent is due.
              */}
            <ConsentGate />
            {isAssistantRoute && isAssistantRole && isChatbotEnabled && <AssistantLauncher />}
        </>
    );
}

export default App;
